import { render, staticRenderFns } from "./superviseDetail.vue?vue&type=template&id=62a71ea2&scoped=true&"
import script from "./superviseDetail.vue?vue&type=script&lang=js&"
export * from "./superviseDetail.vue?vue&type=script&lang=js&"
import style0 from "./superviseDetail.vue?vue&type=style&index=0&id=62a71ea2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a71ea2",
  null
  
)

export default component.exports